import * as React from 'react';
import {
  FITMENT_SELECTOR_STORAGE_KEY,
  SearchBar,
  WsmSearchBarWrapperModal,
} from 'sunhammer-ui';
import styles from './searchBar.module.scss';

interface PlSearchBarProps {
  onSubmit?: (value: string) => void;
}

const PlSearchBar = ({ onSubmit }: PlSearchBarProps) => {
  const [showModal, setShowModal] = React.useState(false);
  const urlSearchParms = new URLSearchParams(window.location.search);
  const query = urlSearchParms.get('q') || '';
  const fitment =
    urlSearchParms.get('fitment') ||
    JSON.parse(
      localStorage.getItem(FITMENT_SELECTOR_STORAGE_KEY) || '{}'
    )?.[0] ||
    '';

  React.useEffect(() => {
    if (showModal) {
      /* Here we use a non react way to focus an element because does not make sense to add a complex
         logic to sunhammer-ui to do this
      */
      setTimeout(() => {
        (
          document.querySelector(
            '.Pl-WsmSearchBarWrapperModal input'
          ) as HTMLInputElement
        )?.focus();
      }, 500);
    }
  }, [showModal]);

  function _onSubmit(data: string) {
    onSubmit?.(data);
  }
  return (
    <>
      <div
        className={styles.searchBarBtnContainer}
        onClick={() => setShowModal(true)}
        onKeyDown={() => null}
        role="button"
        tabIndex={0}
      >
        <SearchBar
          className={styles.searchBar}
          styled={true}
          showCloseIcon={false}
          placeholder="search by keyword or part #..."
          searchValue={query}
          sections={[]}
          onSubmit={() => null}
        />
      </div>

      <WsmSearchBarWrapperModal
        className="Pl-WsmSearchBarWrapperModal"
        styled={true}
        show={showModal}
        showCloseIcon={true}
        placeholder={'search by keyword or part #...'}
        noResultsText="No Results found, please refine your keywords and try again..."
        searchValue={query}
        sections={[
          {
            maxResults: 5,
            title: 'Browse Categories',
            type: 'category',
          },
          {
            maxResults: 5,
            title: 'Browse Brands',
            type: 'brand',
          },
          {
            maxResults: 5,
            onViewMoreClick: () => {
              /* This is a custom logic needed only for WSM clients, so 
                 in this case it's ok to use a non react way to trigger a click.
                 To do this in the react way, we will need to make a complex change
                 in Sunhamme-ui library to send the search value to this callback.
                */
              (
                document.querySelector(
                  '.Pl-WsmSearchBarWrapperModal button.Sui-SearchBar--search-button'
                ) as HTMLButtonElement
              )?.click();
            },
            title: 'Products',
            type: 'product',

            viewMoreButtonText: 'View More Products',
          },
        ]}
        onClose={() => setShowModal(false)}
        onSubmit={_onSubmit}
        fitment={fitment}
      />
    </>
  );
};

export default PlSearchBar;
